export const contactTypeBadgeVariants = {
    Tenant: 'default',
    Owner: 'secondary',
    Buyer: 'accent',
    Seller: 'accent',
    User: 'outline',
    SalesRepresentative: 'warning',
    PropertyManager: 'success',
    MaintenanceCompany: 'destructive',
    Lawyer: 'secondary',
    Accountant: 'secondary',
    TechnicalService: 'outline',
    RealEstateAgent: 'warning',
    AssetPartner: 'accent',
    RentingLead: 'success',
} as const;

export type ContactTypeBadgeVariant = 'success' | 'warning' | 'default' | 'secondary' | 'destructive' | 'outline' | 'accent';

export function getContactTypeBadgeVariant(contactType: string): ContactTypeBadgeVariant {
    return (contactTypeBadgeVariants as Record<string, ContactTypeBadgeVariant>)[contactType] ?? 'outline';
}
